"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactTimeoutButton = void 0;

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var get_classnames_1 = require("../utils/get-classnames");

var constants_1 = require("../constants");

var get_button_text_1 = require("../utils/get-button-text");

var ReactTimeoutButtonOverlay_1 = require("./ReactTimeoutButtonOverlay");

var Button = styled_1.default.button({
  position: 'relative',
  overflow: 'hidden'
});
exports.ReactTimeoutButton = react_1.forwardRef(function (props, ref) {
  var cancelTimeoutOnHover = props.cancelTimeoutOnHover,
      children = props.children,
      className = props.className,
      digits = props.digits,
      overlay = props.overlay,
      overlayBackground = props.overlayBackground,
      overlayOpacity = props.overlayOpacity,
      overlayPosition = props.overlayPosition,
      overlayRtl = props.overlayRtl,
      pauseOnHover = props.pauseOnHover,
      text = props.text,
      timeout = props.timeout,
      onTimeout = props.onTimeout,
      rest = __rest(props, ["cancelTimeoutOnHover", "children", "className", "digits", "overlay", "overlayBackground", "overlayOpacity", "overlayPosition", "overlayRtl", "pauseOnHover", "text", "timeout", "onTimeout"]);

  var _a = __read(react_1.useState({
    buttonText: get_button_text_1.getButtonText(text || '', timeout, digits),
    callbackUsed: false,
    paused: false,
    timeElapsed: 0,
    timeRemaining: timeout,
    timeStarted: Date.now(),
    touched: false
  }), 2),
      _b = _a[0],
      buttonText = _b.buttonText,
      callbackUsed = _b.callbackUsed,
      paused = _b.paused,
      timeElapsed = _b.timeElapsed,
      timeStarted = _b.timeStarted,
      timeRemaining = _b.timeRemaining,
      touched = _b.touched,
      setState = _a[1];

  react_1.useEffect(function () {
    var interval = setInterval(function () {
      if (!paused) {
        var _timeStarted_1 = Date.now();

        var _timeElapsed_1 = timeElapsed + (_timeStarted_1 - timeStarted);

        var _timeRemaining_1 = timeout - timeElapsed;

        if (timeElapsed > timeout || _timeRemaining_1 < 0) {
          _timeElapsed_1 = timeout;
          _timeRemaining_1 = 0;
        }

        var buttonText_1 = get_button_text_1.getButtonText(text || '', _timeRemaining_1, digits);
        setState(function (state) {
          return __assign(__assign({}, state), {
            timeStarted: _timeStarted_1,
            timeElapsed: _timeElapsed_1,
            timeRemaining: _timeRemaining_1,
            buttonText: buttonText_1
          });
        });
      }
    }, 4);

    if (timeRemaining <= 0 || touched && cancelTimeoutOnHover) {
      var buttonText_2 = get_button_text_1.getButtonText(text || '', 0);
      setState(function (state) {
        if (onTimeout && !callbackUsed && !(touched && cancelTimeoutOnHover)) {
          onTimeout();
        }

        return __assign(__assign({}, state), {
          callbackUsed: true,
          timeRemaining: 0,
          timeElapsed: timeout,
          buttonText: buttonText_2
        });
      });
      clearInterval(interval);
    }

    return function () {
      return clearInterval(interval);
    };
  }, [paused, timeElapsed, timeStarted, timeRemaining, touched, callbackUsed]);

  var handleTimedPause = function (e, fn) {
    fn && fn(e);
    setState(function (state) {
      return __assign(__assign({}, state), {
        paused: pauseOnHover ? true : false,
        touched: true
      });
    });
  };

  var handleTimedResume = function (e, fn) {
    fn && fn(e);

    if (pauseOnHover) {
      setState(function (state) {
        return __assign(__assign({}, state), {
          paused: false,
          timeStarted: Date.now()
        });
      });
    }
  };

  var allowOverlay = overlay && !(touched && cancelTimeoutOnHover);
  var classNames = get_classnames_1.getClassnames(className);
  return react_1.default.createElement(Button, __assign({
    className: classNames
  }, rest, {
    onMouseEnter: function (e) {
      handleTimedPause(e, props.onMouseEnter);
    },
    onMouseLeave: function (e) {
      handleTimedResume(e, props.onMouseLeave);
    },
    ref: ref
  }), allowOverlay && overlayPosition === 'before' && react_1.default.createElement(ReactTimeoutButtonOverlay_1.ReactTimeoutButtonOverlay, {
    className: constants_1.COMPONENT_ID + "__overlay " + constants_1.COMPONENT_ID + "__overlay--before",
    color: overlayBackground,
    opacity: overlayOpacity,
    paused: paused,
    timeout: timeout,
    rtl: overlayRtl
  }), children, text && react_1.default.createElement("span", {
    style: {
      minWidth: '100%'
    },
    className: constants_1.COMPONENT_ID + "__text"
  }, buttonText), allowOverlay && overlayPosition === 'after' && react_1.default.createElement(ReactTimeoutButtonOverlay_1.ReactTimeoutButtonOverlay, {
    className: constants_1.COMPONENT_ID + "__overlay " + constants_1.COMPONENT_ID + "__overlay--after",
    color: overlayBackground,
    opacity: overlayOpacity,
    paused: paused,
    timeout: timeout,
    rtl: overlayRtl
  }));
});
exports.ReactTimeoutButton.defaultProps = {
  digits: 0,
  overlay: false,
  overlayPosition: 'before',
  overlayOpacity: 0.15,
  overlayBackground: '#000000'
};